//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.Optional
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List

public data class UpsertInspectionCommandInput(
  public val id: Any,
  public val inspectionId: Any,
  public val questionId: Any,
  public val answer: Optional<String?> = Optional.Absent,
  public val optionId: Optional<Any?> = Optional.Absent,
  public val isFlagged: Optional<Boolean?> = Optional.Absent,
  public val notes: Optional<String?> = Optional.Absent,
  public val findingCategory: Optional<FindingCategory?> = Optional.Absent,
  public val media: Optional<List<InspectionMediaDtoInput>?> = Optional.Absent,
)
